<app-reactive-dialog-content [data]="dialogInputData">
  <div class="infotext-kp">
    <ng-container *ngFor="let listItem of listText">
      <ng-container *ngTemplateOutlet="nestedlist, context: {data: listItem}">
      </ng-container>
    </ng-container>
  </div>
  <div class="button-container">
    <button mat-raised-button color="accent" (click)="close()">OK</button>
  </div>
</app-reactive-dialog-content>
<ng-template #nestedlist let-data="data">
  <div [innerHTML]="data.text"></div>
  <ol *ngIf="data.ordered && data.subtexts"
      [ngClass]="{
      'upper-roman': data.listTypeClass === 'upper-roman',
      'lower-alpha': data.listTypeClass === 'lower-alpha'
      }">
    <ng-container *ngTemplateOutlet="listitems, context: { subtexts: data.subtexts }">
    </ng-container>
  </ol>
  <ul *ngIf="!data.ordered && data.subtexts"
      [ngClass]="{
      'circle': data.listTypeClass === 'circle',
      'square': data.listTypeClass === 'square'
      }">
    <ng-container *ngTemplateOutlet="listitems, context: { subtexts: data.subtexts }">
    </ng-container>
  </ul>
</ng-template>

<ng-template #listitems let-subtexts="subtexts">
  <li *ngFor="let subitem of subtexts">
    <ng-container *ngTemplateOutlet="nestedlist, context: {data: subitem}"></ng-container>
  </li>
</ng-template>
